import { createFileRoute } from '@tanstack/react-router';

import { getPickTicketsQueryOptions } from '@/_pages/pick-tickets/api-service';
import Loading from '@/_pages/pick-tickets/profile/loading';

export const Route = createFileRoute('/_private/pick-tickets/$id')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getPickTicketsQueryOptions(opts.params.id)),
  pendingComponent: Loading,
});
